export default __webpack_public_path__ + "static/media/shield-search.5a95c528.svg";